/** Tipos das integrações */
export interface IntegrationTipo {
    id: number;
    nome: string;
}

export const tipoLeituraClientesGeral: IntegrationTipo = {id: 1, nome: 'Leitura geral dos Clientes'};
export const tipoLeituraRepresentantesGeral: IntegrationTipo = {id: 2, nome: 'Leitura geral dos Representantes'};
export const tipoLeituraItensUpdateGeral: IntegrationTipo = {id: 3, nome: 'Atualização geral dos Itens'};
export const tipoLeituraTransportadorasGeral: IntegrationTipo = {id: 4, nome: 'Leitura geral das transportadoras'};
export const tipoLeituraPedidosMensal: IntegrationTipo = {id: 5, nome: 'Leitura mensal dos Pedidos'};
export const tipoLeituraNotasFiscaisDiaria: IntegrationTipo = {id: 6, nome: 'Leitura diaria das Notas Fiscais'};
export const tipoLeituraPedidosUpdateMensal: IntegrationTipo = {id: 7, nome: 'Atualização mensal dos Pedidos'};
export const tipoLeituraPedidosUpdateGeral: IntegrationTipo = {id: 8, nome: 'Atualização geral dos Pedidos'};
export const tipoLeituraPedidosErpMensal: IntegrationTipo = {id: 9, nome: 'Leitura mensal dos Pedidos lançados no ERP'};
export const tipoLeituraPedidosErpGeral: IntegrationTipo = {id: 10, nome: 'Leitura geral dos Pedidos lançados no ERP'};
export const tipoLeituraTitulosReceberDiaria: IntegrationTipo = {id: 13, nome: 'Leitura diária dos Títulos'};
export const tipoLeituraTitulosReceberGeral: IntegrationTipo = {id: 14, nome: 'Leitura geral dos Títulos'};
export const tipoLeituraPedidosGeral: IntegrationTipo = {id: 15, nome: 'Leitura geral dos Pedidos'};
export const tipoLeituraNotasFiscaisGeral: IntegrationTipo = {id: 16, nome: 'Leitura geral das Notas Fiscais'};
export const tipoLeituraClientesTipos: IntegrationTipo = {id: 17, nome: 'Leitura dos Tipos de Clientes'};
export const tipoLeituraClientesGrupos: IntegrationTipo = {id: 18, nome: 'Leitura dos Grupos de Clientes'};
export const tipoLeituraItensTipos: IntegrationTipo = {id: 19, nome: 'Leitura dos Tipos de Itens'};
export const tipoLeituraUnidadesNegocios: IntegrationTipo = {id: 20, nome: 'Leitura das Unidades de Negócio'};
export const tipoLeituraLinhasProducoes: IntegrationTipo = {id: 21, nome: 'Leitura das Linhas de Produção'};
export const tipoLeituraNaturezasVendas: IntegrationTipo = {id: 22, nome: 'Leitura das Naturezas de Venda'};
export const tipoLeituraItensGeral: IntegrationTipo = {id: 23, nome: 'Leitura geral dos itens'};
export const tipoLeituraItensUnidades: IntegrationTipo = {id: 24, nome: 'Leitura das unidades dos itens'};
export const tipoLeituraPedidosErpAnual: IntegrationTipo = {id: 25, nome: 'Leitura anual dos Pedidos lançados no ERP'};
export const tipoLeituraTitulosReceberAnual: IntegrationTipo = {id: 26, nome: 'Leitura anual dos Títulos'};
export const tipoLeituraPedidosAnual: IntegrationTipo = {id: 27, nome: 'Leitura anual dos Pedidos'};
export const tipoLeituraPedidosUpdateAnual: IntegrationTipo = {id: 28, nome: 'Atualização anual dos Pedidos'};
export const tipoLeituraComissaoDiaria: IntegrationTipo = {id: 29, nome: 'Leitura diária das comissões'};
export const tipoLeituraComissaoAnual: IntegrationTipo = {id: 30, nome: 'Leitura anual das comissões'};
export const tipoLeituraComissaoGeral: IntegrationTipo = {id: 31, nome: 'Leitura geral das comissões'};
export const tipoLeituraClientesDiaria: IntegrationTipo = {id: 32, nome: 'Leitura diária dos clientes'};
export const tipoLeituraClientesSemanal: IntegrationTipo = {id: 33, nome: 'Leitura semanal dos clientes'};
export const tipoLeituraClientesMensal: IntegrationTipo = {id: 34, nome: 'Leitura mensal dos clientes'};
export const tipoLeituraClientesAnual: IntegrationTipo = {id: 35, nome: 'Leitura anual dos clientes'};
export const tipoLeituraRepresentantesDiaria: IntegrationTipo = {id: 36, nome: 'Leitura diária dos Representantes'};
export const tipoLeituraRepresentantesSemanal: IntegrationTipo = {id: 37, nome: 'Leitura semanal dos Representantes'};
export const tipoLeituraRepresentantesMensal: IntegrationTipo = {id: 38, nome: 'Leitura mensal dos Representantes'};
export const tipoLeituraRepresentantesAnual: IntegrationTipo = {id: 39, nome: 'Leitura anual dos Representantes'};
export const tipoLeituraCarteiraPedidoMensal: IntegrationTipo = {id: 40, nome: 'Leitura mensal da carteira de pedidos'};
export const tipoLeituraCarteiraPedidoAnual: IntegrationTipo = {id: 41, nome: 'Leitura anual da carteira de pedidos'};
export const tipoLeituraCarteiraPedidoGeral: IntegrationTipo = {id: 42, nome: 'Leitura geral da carteira de pedidos'};
export const tipoLeituraNotasFiscaisMensal: IntegrationTipo = {id: 43, nome: 'Leitura mensal das Notas Fiscais'};
export const tipoSaveCliente: IntegrationTipo = {id: 44, nome: 'Salvar cliente no ERP'};
export const tipoSyncCliente: IntegrationTipo = {id: 45, nome: 'Sincronizar clientes com o ERP'};
export const tipoLeituraPedidosAnaliseFinanceira: IntegrationTipo = {id: 46, nome: 'Leitura para a análise financeira dos pedidos'};
export const tipoSavePedido: IntegrationTipo = {id: 47, nome: 'Salvar pedido no ERP'};
export const tipoLeituraPedidoIndividual: IntegrationTipo = {id: 48, nome: 'Leitura individual do pedido'};
export const tipoLeituraItensDiaria: IntegrationTipo = {id: 49, nome: 'Leitura diária dos itens'};
export const tipoLeituraItensUpdateDiaria: IntegrationTipo = {id: 50, nome: 'Atualização diária dos Itens'};
export const tipoLeituraItemIndividual: IntegrationTipo = {id: 51, nome: 'Leitura individual do item'};
export const tipoLeituraClienteIndividual: IntegrationTipo = {id: 52, nome: 'Leitura individual do cliente'};
export const tipoLeituraRepresentanteIndividual: IntegrationTipo = {id: 53, nome: 'Leitura individual do representante'};
export const tipoLeituraTransportadorasDiaria: IntegrationTipo = {id: 54, nome: 'Leitura diária das transportadoras'};
export const tipoLeituraTransportadorasSemanal: IntegrationTipo = {id: 55, nome: 'Leitura semanal das transportadoras'};
export const tipoLeituraTransportadorasMensal: IntegrationTipo = {id: 56, nome: 'Leitura mensal das transportadoras'};
export const tipoLeituraTransportadorasAnual: IntegrationTipo = {id: 57, nome: 'Leitura anual das transportadoras'};
export const tipoLeituraTransportadoraIndividual: IntegrationTipo = {id: 58, nome: 'Leitura individual da transportadora'};
export const tipoLeituraNotaFiscalIndividual: IntegrationTipo = {id: 59, nome: 'Leitura individual da nota fiscal'};
export const tipoLeituraTituloReceberIndividual: IntegrationTipo = {id: 60, nome: 'Leitura individual do título a receber'};
export const tipoLeituraComissaoIndividual: IntegrationTipo = {id: 61, nome: 'Leitura individual da comissão'};
export const tipoLeituraCarteiraPedidoIndividual: IntegrationTipo = {id: 62, nome: 'Leitura individual da carteira de pedido'};
export const tipoLeituraNotasFiscaisSemanal: IntegrationTipo = {id: 63, nome: 'Leitura semanal das Notas Fiscais'};
export const tipoLeituraComissaoMensal: IntegrationTipo = {id: 64, nome: 'Leitura mensal das comissões'};
export const tipoLeituraFormaPagamento: IntegrationTipo = {id: 65, nome: 'Leitura das formas de pagamentos'};
export const tipoLeituraCondicaoPagamento: IntegrationTipo = {id: 66, nome: 'Leitura das condições de pagamentos'};
export const tipoLeituraPedidosErpDiaria: IntegrationTipo = {id: 67, nome: 'Leitura diária dos Pedidos lançados no ERP'};
export const tipoLeituraClassificacoes: IntegrationTipo = {id: 68, nome: 'Leitura das classificações'};
export const tipoLeituraPedidosDiaria: IntegrationTipo = {id: 69, nome: 'Leitura diária dos Pedidos'};
export const tipoLeituraMercados: IntegrationTipo = {id: 70, nome: 'Leitura dos Mercados'};
export const tipoLeituraClientesDataAlteracao: IntegrationTipo = {id: 71, nome: 'Leitura dos clientes alterados recentemente'};
export const tipoLeituraItensDataAlteracao: IntegrationTipo = {id: 72, nome: 'Leitura dos itens alterados recentemente'};

export const integracaoTipos: IntegrationTipo[] = [
    tipoLeituraClientesGeral,
    tipoLeituraRepresentantesGeral,
    tipoLeituraItensUpdateGeral,
    tipoLeituraTransportadorasGeral,
    tipoLeituraPedidosDiaria,
    tipoLeituraPedidosMensal,
    tipoLeituraNotasFiscaisDiaria,
    tipoLeituraPedidosUpdateMensal,
    tipoLeituraPedidosUpdateGeral,
    tipoLeituraPedidosErpDiaria,
    tipoLeituraPedidosErpMensal,
    tipoLeituraPedidosErpGeral,
    tipoLeituraTitulosReceberDiaria,
    tipoLeituraTitulosReceberGeral,
    tipoLeituraPedidosGeral,
    tipoLeituraNotasFiscaisGeral,
    tipoLeituraClientesTipos,
    tipoLeituraClientesGrupos,
    tipoLeituraItensTipos,
    tipoLeituraUnidadesNegocios,
    tipoLeituraLinhasProducoes,
    tipoLeituraNaturezasVendas,
    tipoLeituraItensGeral,
    tipoLeituraItensUnidades,
    tipoLeituraPedidosErpAnual,
    tipoLeituraTitulosReceberAnual,
    tipoLeituraPedidosAnual,
    tipoLeituraPedidosUpdateAnual,
    tipoLeituraComissaoDiaria,
    tipoLeituraComissaoAnual,
    tipoLeituraComissaoGeral,
    tipoLeituraClientesDiaria,
    tipoLeituraClientesSemanal,
    tipoLeituraClientesMensal,
    tipoLeituraClientesAnual,
    tipoLeituraRepresentantesDiaria,
    tipoLeituraRepresentantesSemanal,
    tipoLeituraRepresentantesMensal,
    tipoLeituraRepresentantesAnual,
    tipoLeituraCarteiraPedidoMensal,
    tipoLeituraCarteiraPedidoAnual,
    tipoLeituraCarteiraPedidoGeral,
    tipoLeituraNotasFiscaisMensal,
    tipoSaveCliente,
    tipoSyncCliente,
    tipoLeituraPedidosAnaliseFinanceira,
    tipoSavePedido,
    tipoLeituraPedidoIndividual,
    tipoLeituraItensDiaria,
    tipoLeituraItensUpdateDiaria,
    tipoLeituraItemIndividual,
    tipoLeituraClienteIndividual,
    tipoLeituraRepresentanteIndividual,
    tipoLeituraTransportadorasDiaria,
    tipoLeituraTransportadorasSemanal,
    tipoLeituraTransportadorasMensal,
    tipoLeituraTransportadorasAnual,
    tipoLeituraTransportadoraIndividual,
    tipoLeituraNotaFiscalIndividual,
    tipoLeituraTituloReceberIndividual,
    tipoLeituraComissaoIndividual,
    tipoLeituraCarteiraPedidoIndividual,
    tipoLeituraNotasFiscaisSemanal,
    tipoLeituraComissaoMensal,
    tipoLeituraFormaPagamento,
    tipoLeituraCondicaoPagamento,
    tipoLeituraClassificacoes,
    tipoLeituraMercados,
    tipoLeituraClientesDataAlteracao,
    tipoLeituraItensDataAlteracao
];
